import OffersHelper from '@/classes/offers_helper.js'
import TimeHelper from '@/classes/time_helper.js'
import { formatSalary } from '@/classes/my_utils.js'

class Reports {

	constructor(offers, sum_field_option){
		this.offers_helper = new OffersHelper()
		this.time_helper = new TimeHelper()
		this.offers = Array.isArray(offers) ? offers : (offers ? [offers] : [])
		this.sum_field_option = sum_field_option
		this.reports = []
		this.setReports()
	}

	setReports(){
		let reports = this.mapReports()
		this.mapReadableReports(reports)
		this.sortReports()
	}

	getReports(){
		return this.reports
	}

	mapReports(){
		let reports = {}
		this.offers.forEach(offer => {
			if(offer[this.getSumFieldOption()] == undefined){
				return
			}
			let sum_field_option_date = new Date(offer[this.getSumFieldOption()])
			let year = sum_field_option_date.getFullYear()
			let month = sum_field_option_date.getMonth()
			// Year
			if(reports[year] == undefined){
				reports[year] = []
			}
			// Month Offers
			if(reports[year][month] == undefined){
				reports[year][month] = []
			}
			reports[year][month].push(offer)
		})
		return reports
	}

	mapReadableReports(reports){
		for(let report_year in reports){
			let report = reports[report_year]
			for(let month in report){
				let offers = report[month]
				let month_income = 0
				for(let i = 0; i < offers.length; i++){
					month_income += this.offers_helper.getPayment(offers[i], false)
				}
				this.reports.push({
					year: report_year,
					month: {
						display_text: this.time_helper.getReadableMonth(month),
						value: month
					},
					income: {
						display_text: formatSalary(month_income),
						value: month_income
					},
					offers
				})
			}
		}
	}

	sortReports(){
		this.reports.sort((a, b) => {
			let a_date = new Date()
			a_date.setFullYear(a.year)
			a_date.setMonth(a.month.value)
			let b_date = new Date()
			b_date.setFullYear(b.year)
			b_date.setMonth(b.month.value)
			return b_date.getTime() - a_date.getTime()
		})
	}

	getTotalIncome(){
		let total_income = 0
		for(let i = 0; i < this.reports.length; i++){
			total_income += this.reports[i].income.value
		}
		return formatSalary(total_income)
	}

	getSumFieldOption(){
		return this.sum_field_option || 'start_date'
	}

}

export default Reports;